<template>
    <div class="tab-pane fade show active position-relative" id="activity">
        <transition name="vue-table-loader">
	        <div class="vue-details-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-1x"></span></div>
	    </transition>
        <div class="product-form-tab">
            <div class="form-element-container">
                <div class="row">
                    <div class="col-md-7 clearfix">
                        <h3 class="mt-2">Activity</h3>
                    </div>
                    <div class="col-md-5">
                        <div class="search-container">
                            <base-filter-bar placeholder="Search Activity"></base-filter-bar>
                        </div>
                    </div>
                </div>
                <div class="dataTables_wrapper container-fluid dt-bootstrap4">
                    <vuetable ref="vuetable"
                        :api-url="grid"
                        :fields="fields"
                        :css="css.table"
                        :per-page="perPage"
                        :append-params="moreParams"
                        noDataTemplate="No Activity Found"
                        pagination-path=""
                        @vuetable:pagination-data="onPaginationData"
                        @vuetable:loaded="onLoaded"
                    >
                        <template slot="description-slot" slot-scope="props">
                            <span data-toggle="tooltip" data-placement="top" :title="props.rowData.description" style="white-space: pre-line">{{ props.rowData.description }}</span>
                        </template>
                        <template slot="details" slot-scope="props">
                            <div class="btn btn-outline-primary" v-on:click="displayMessage(props.rowData.details)"><i class="fa" aria-hidden="true"></i> View Details</div>
                        </template>
                    </vuetable>

                    <div class="row">
                        <div class="col-md-6">
                            <base-pagination-info
                                :css="css.table"
                                ref="paginationInfo"
                            >
                            </base-pagination-info>
                        </div>
                        <div class="col-md-6">
                            <base-pagination  ref="pagination"
                            @vuetable-pagination:change-page="onChangePage"
                            ></base-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade" id="modalLogMessage">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Message</h4>
                    </div>
                    <div class="modal-body modal-longtext">
                        <div>{{ current_message.message }}</div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var base_url = window.location.protocol + "//" + window.location.host
import Vue from 'vue';
import axios from 'axios'
import * as Vuetable from 'vuetable-2';
import VueEvents from 'vue-events'
import BasePagination from '../tables/base-pagination.vue';
import BasePaginationInfo from '../tables/base-pagination-info.vue';
import BaseFilterBar from '../tables/base-filter-bar.vue';
import moment from 'moment-timezone';

Vue.use(VueEvents)

export default {
    name: 'product-activity',
    components: {
        'base-pagination': BasePagination,
        'base-filter-bar': BaseFilterBar,
        'base-pagination-info': BasePaginationInfo,
    },
    data() {
        return {
            perPage: 10,
            loading: true,
	    	moreParams: {},
            uiStates: {
                errorMessage: null,
                showLoading: true
            },
            product: this.productDetails,
            productActivity: [],
            current_message: {
                message: null
            },
            fields: [
				{
                    name: 'user_name',
                    title: 'User',
                },
                {
                    name: 'action',
                    title: 'Action',
                },
                {
                    name: '__slot:description-slot',
                    title: '',
                },
                {
                    name: "__slot:details",
                    title: "Details"
                },
                {
                    name: 'updated_at',
                    title: 'Updated',
                    callback: 'formatDate',
                },
            ],
            grid: base_url + '/pimapi/products/' + this.$parent.product.info.id + '/activities',
            css: {
                table: {
                    tableClass: 'table table-middle table-minimal',
                    ascendingIcon: 'sort-icon-asc',
                    descendingIcon: 'sort-icon-desc',
                    infoClass: '',
                },
            }
        }
    },
    mounted() {
        this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
        this.$events.$on('filter-reset', e => this.onFilterReset())
    },
    methods: {
        displayMessage(message) {
            if (message != "") {
                this.current_message.message = message;
            } else {
                this.current_message.message = "No Details";
            }
            $("#modalLogMessage").modal("show");
        },
        formatDate (value) {
            if (value === null) {
                return 'Never';
            }
            if(this.$parent.clientTimezone){
                return moment.utc(value).tz(this.$parent.clientTimezone).format('MMM Do YYYY h:mm a');
            } else {
                return moment(value).format("MMM Do YYYY, h:mm a");
            }
        },
        onChangePage (page) {
            this.$refs.vuetable.changePage(page)
        },
        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData)
            this.$refs.paginationInfo.setPaginationData(paginationData)
        },
        onLoaded: function() {
            this.loading = false;
            this.current_message = {
                message: null,
            }
        },
        onFilterSet (filterText) {
            this.moreParams = {
                'filter': filterText
            }
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        },
        onFilterReset () {
            this.moreParams = {}
            Vue.nextTick( () => this.$refs.vuetable.refresh())
        }
    }
}
</script>

<style lang="scss" scoped>
    .activities-table {
        min-height: 680px;
    }
    .search-container{
        text-align: right;
        float: right;
        width: 300px;
    }
    .filter-bar{
        &:after {
            display: block;
            clear: both;
            content: "";
        }
    }
</style>

<style lang="scss">
    .table-minimal {
        thead {
            tr{
                th {
                    font-size: 13px;
                    color: #434343;
                    text-align: left;
                    font-weight: 800;
                    padding-top: 15px;
                    padding-bottom: 15px;
                    &:first-of-type{
                        border-left: 1px solid #dee0e1;
                    }
                    &:last-of-type{
                        border-right: 1px solid #dee0e1;
                    }
                }
            }
        }

        tr{
            td {
                border-top: 1px solid #dee0e1;
                font-size: 12px;
                color: #676767;
                text-align: left;
                font-weight: 800;
                padding: 20px 20px;
            }
            &:last-child{
                td{
                    border-bottom: 1px solid #dee0e1;
                }
            }
        }
    }
</style>
